export default "__VITE_ASSET__Cp1$VJta__"